<template>
  <div class="inquiry_index">
    <div class="inquiry_title">
      <el-icon class="el-icon-edit-outline"></el-icon> 询报价
    </div>
    <div class="inquiry_form">
      <div class="inquiry_form_one_title">
        主条款
      </div>
      <div class="inquiry_form_one">
        <el-tag type="primary" class="inquiry_form_one_tag" v-for="mitem in product.main_terms" :key="mitem.id" @click="showDetail('main',mitem.id)">{{mitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.additional_terms && product.additional_terms.length>0">
        附加额外条款
      </div>
      <div class="inquiry_form_one" v-if="product.additional_terms && product.additional_terms.length>0">
        <el-tag type="primary" class="inquiry_form_one_tag" v-for="aitem in product.additional_terms" :key="aitem.id" @click="showDetail('additional',aitem.id)">{{aitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.special_terms && product.special_terms.length>0">
        特殊约定
      </div>
      <div class="inquiry_form_one" v-if="product.special_terms && product.special_terms.length>0">
        <el-tag type="warning" class="inquiry_form_one_tag" v-for="sitem in product.special_terms" :key="sitem.id" @click="showDetail('special',sitem.id)">{{sitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.deductible_terms && product.deductible_terms.length>0">
        免赔责任
      </div>
      <div class="inquiry_form_one" v-if="product.deductible_terms && product.deductible_terms.length>0">
        <el-tag type="danger" class="inquiry_form_one_tag" v-for="ditem in product.deductible_terms" :key="ditem.id" @click="showDetail('deductible',ditem.id)">{{ditem.title}}</el-tag>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>船舶信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one" v-if="form.mmsi">
        <div class="inquiry_form_title">
          船舶MMSI
        </div>
        <div class="inquiry_form_input">
          {{ form.mmsi }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶名称 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.ship_name}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶类型 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.ship_type}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          总吨
        </div>
        <div class="inquiry_form_input">
          {{form.gross_tonnage}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          载重 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.dwt}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船籍港 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.home_port}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          航行区域 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <span v-for="(item,index) in area_types" v-if="form.area!=null && index.toString()===form.area.toString()">{{item}}</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          造船厂 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.builder }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          建造年份 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.build_year }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          所有人 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.ship_owner }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船级社 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.classification_society }}
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>保险信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险起期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ new Date(form.insurance_begin*1000).toLocaleDateString()}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险止期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ new Date(form.insurance_stop*1000).toLocaleDateString()}}
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>投保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_name }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_email }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_phone }}
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>被保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_name }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_email }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_phone }}
        </div>
      </div>

      <div v-if="form.state > 0">
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            <b>保险联系人</b>
          </div>
          <div class="inquiry_form_input">

          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            姓名 <span class="inquiry_red_star">*</span>
          </div>
          <div class="inquiry_form_input">
            {{ form.insurance_name }}
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            邮箱
          </div>
          <div class="inquiry_form_input">
            {{ form.insurance_email }}
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            手机 <span class="inquiry_red_star">*</span>
          </div>
          <div class="inquiry_form_input">
            {{ form.insurance_phone }}
          </div>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>其他信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶证书
        </div>
        <div class="inquiry_form_input">
          <el-image
            v-for="(item,index) in form.shipcerts" :src="item" :key="index"
            style="height:1.5rem;border:1px solid #ddd;"
            :preview-src-list="form.shipcerts">
            <div slot="error" class="image-slot">
              <i class="el-icon-collection">{{item.substring(item.lastIndexOf(".")+1).toUpperCase()}}</i>
            </div>
          </el-image>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>询报价结果</b>
        </div>
        <div class="inquiry_form_input">
          <span :style="'color:'+stateColor[form.state]+';'">{{states[form.state]}}</span>
        </div>
      </div>
      <div v-if="form.state > 0">
        <div v-if="form.insurance_coverage == 0">
          <div class="inquiry_form_title">
          </div>
          <div class="inquiry_form_input">
            <el-tag>线下报价单,请直接联系保司</el-tag>
          </div>
        </div>
        <div v-else>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              费率 ( % )
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_rate || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              保额 ( 元 )
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_coverage || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              付款期限
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_payment_method_deadline || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              赔付地点
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_place || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              付款约定
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_payment_agreement || '无' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inquiry_bottom">
      <el-button type="primary" style="width:90%;margin:0 5%;float:left;" @click="insuranceCancel" v-if="form.state===0">取消询价</el-button>
      <el-tag type="danger" style="width:90%;margin:0 5%;float:left;text-align:center;" v-if="form.state===1">已投保</el-tag>
      <el-tag type="info" style="width:90%;margin:0 5%;float:left;text-align:center;" v-if="form.state===4">已取消</el-tag>
    </div>
    <el-dialog
      :title="dtypes[dtype]"
      :visible.sync="detailDialogVisible" fullscreen>
      <h3>《{{ detail.title }}》</h3>
      <div v-html="detail.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getDomain,insuranceOrderGet,addInsuranceOrder,getInsuranceProductsById,insuranceMainTermsById,insuranceAdditionalTermsById,insuranceSpecialTermsById,insuranceDeductibleTermsById } from '../../api/api'

  export default {
    name: "InquiryAdd",
    data() {
      return {
        oid:this.$route.query.oid,
        domain:getDomain(),
        product:{},
        mains:[],
        additionals:[],
        keyword:'',
        ktimeout:null,
        ksearching:false,
        ships:[],
        dialogVisible:false,
        area_types:['内河','远洋','沿海'],
        states:['待报价','已报价','已取消'],
        stateColor:['#59c2e4','#f1c16b','#67c23a','#f56c6c','#8f8f8f'],
        imgs:[],
        form:{
          ship_name:null,
          mmsi:null,
          dwt:null,
          gross_tonnage:null,
          area:null,
          ship_owner:null,
          ship_type:null,
          home_port:null,
          build_year:null,
          valuation:null,
          classification_society:null,
          insurance_begin:new Date().valueOf(),
          insurance_stop: new Date().valueOf()+86400000*365,
          shipcerts:[],
          rfq_name:null,
          rfq_email:null,
          rfq_phone:null,
          modeltype:null
        },
        maxsize:1024*1024*10,
        dtype:'',
        detail:{},
        detailDialogVisible:false,
        dtypes:{'main':'主险','additional':'附加险','special':'特别约定','deductible':'免赔条款'}
      }
    },
    mounted() {
      insuranceOrderGet(this.oid).then(res => {
        if(res && res.status===0){
          res.data.insurance_additional_terms = JSON.parse(res.data.insurance_additional_terms);
          res.data.shipcerts = JSON.parse(res.data.shipcerts);
          this.form = JSON.parse(JSON.stringify(res.data));
          getInsuranceProductsById(this.form.insurance_products).then(res => {
            if(res && res.status === 0 && res.data){
              this.product = res.data;
            }
          });
        }else{
          this.$router.push('/inquiry/index');
        }
      });
    },
    methods: {
      insuranceCancel(){
        addInsuranceOrder({oid:this.oid,state:2}).then(res=>{
          if(res && res.status === 0){
            this.$router.push('/inquiry/index');
          }
        });
      },
      insuranceSubmit(){
        addInsuranceOrder({oid:this.oid,state:2}).then(res=>{
          if(res && res.status === 0){
            this.$router.push('/inquiry/index');
          }
        });
      },
      showDetail(dtype,id){
        this.dtype = dtype;
        switch(dtype){
          case 'main':
            insuranceMainTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'additional':
            insuranceAdditionalTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'special':
            insuranceSpecialTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'deductible':
            insuranceDeductibleTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          default:
            break;
        }
      }
    }
  }
</script>

<style scoped>
  .inquiry_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #fefefe;
    overflow-y: scroll;
  }
  .inquiry_title {
    height:2rem;
    line-height:2rem;
    text-indent: .5rem;
    font-size:.95rem;
    color:#03a7d5;
  }
  .inquiry_bottom {
    width:100%;
    position:absolute;
    bottom:0;
    height:4rem;
    line-height:4rem;
    border-top:1px #ddd dashed;
  }
  .inquiry_form {
    height:79vh;
    overflow-y: scroll;
  }
  .inquiry_form_one {
    float:left;
    min-height:1.2rem;
    line-height:1.2rem;
    width:90%;
    margin:.5rem 5%;
  }
  .inquiry_form_title {
    width:20%;
    float:left;
    font-size:.8rem;
    color:#666;
    height:1.2rem;
    line-height:1.2rem;
  }
  .inquiry_form_input {
    margin-left:3%;
    width:75%;
    float:left;
    height:1.2rem;
    line-height:1.2rem;
    font-size:.8rem;
  }
  .inquiry_media_box {
    width:100%;
    height:5rem;
    overflow:hidden;
  }
  .inquiry_media_one {
    height:5rem;
    width:20%;
    margin:.5rem 5%;
  }
  .inquiry_form_one_title {
    float:left;
    font-size:.8rem;
    color:#03a7d5;
    height:1.2rem;
    line-height:1.2rem;
    text-indent: 1rem;
  }
  .inquiry_ships_main {
    position: absolute;
    top:0;
    left:2%;
    width:96%;
    height:94vh;
    background:rgba(255,255,255,0.95);
    z-index:999;
  }
  .inquiry_ships_title {
    height:2rem;
    line-height:2rem;
    font-size:1rem;
    text-indent: .5rem;
  }
  .inquiry_ships_one {
    height:6rem;
    width:96%;
    margin-left:2%;
    border-top:1px dashed #ccc;
  }
  .inquiry_ships_line {
    width:100%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.8rem;
    color:grey;
  }
  .inquiry_ships_half_line {
    width:49%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.8rem;
    color:grey;
  }
  .inquiry_red_star {
    color:red;
  }
  .inquiry_form_one_tag {
    max-width:100%;
    overflow-x: scroll;
    margin-right:.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/inquiry/review.vue